import React from 'react';
import CourseList from './CourseList';

const CourseListCategories = ({ data , Column}) => {
    return (
        <div className="row row--15 mt_dec--30">
            {data.map((single, key) => {
                return(
                    <div key={key} className={`${Column}`}>
                        <CourseList data={single} key={key} />
                    </div>
                ); 
            })}
        </div>
    )
}
export default CourseListCategories;
